import axiosInstance from './apiinterseptor';

export interface CandidateLead {
  _id: string;
  name: string;
  email?: string;
  mobile?: string;
  type?: 'company' | 'jobseeker' | 'recruter';
  createdAt?: string;
  updatedAt?: string;
}

export interface GetCandidateLeadsResponse {
  success: boolean;
  data: {
    leads: CandidateLead[];
    totalCount: number;
    totalPages: number;
    currentPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
  message: string;
}

export interface GetCandidateLeadsParams {
  page?: number;
  limit?: number;
}

export const getCandidateLeads = async (
  params: GetCandidateLeadsParams = {}
): Promise<GetCandidateLeadsResponse> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page.toString());
  if (params.limit) queryParams.append('limit', params.limit.toString());

  const apiUrl = `/candidateLeads?${queryParams.toString()}`;

  const response = await axiosInstance.get(apiUrl);
  return response.data;
};

